import { render, staticRenderFns } from "./Queries.vue?vue&type=template&id=af70345e&"
import script from "./Queries.vue?vue&type=script&lang=js&"
export * from "./Queries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports